'use client';

import { createContext } from 'react';

import type { ToggleCardRootContextInterface } from '../types/toggle-card-root.context.types';

export const ToggleCardRootContext = createContext<ToggleCardRootContextInterface>({
  setLabelId: () => {},
  triggerProps: {},
  rootProps: {
    disabled: false,
    elevated: true,
    outlined: true,
    selected: false,
    tone: 'neutral',
  },
});

ToggleCardRootContext.displayName = 'ToggleCard.Root.Context';
